import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    language_list: [],
    active_language: {
      language_code:"en",
      language_name:"English"
    }
  };
  
  const changeLanguageStateSlice = createSlice({
    name: 'account',
    initialState: initialState,
    reducers: {
      listAccount: (state, action) => {
        state.account_list = action.payload
      },
      activeAccount: (state,action) => {
        state.active_account= action.payload 
      }
    }
  });
  
  export const { listAccount, activeAccount } = changeLanguageStateSlice.actions;
  
  export default changeLanguageStateSlice.reducer;